import accountBenefits from './account-benefits'
import communityM from './community'
import communities from './communities'
import contentEngine from './content-engine'
import contentRequests from './content-requests'
import contents from './contents'
import esports from './esports'
import gameClaims from './gameClaims'
import gameContributions from './gameContributions'
import gameCreationSuggestions from './gameCreationSuggestions'
import guestWriterInvites from './guest-writer-invites'
import moderation from './moderation'
import reports from './reports'
import showcaseCoverage from './showcase-coverage'
import appThemes from './themes'
import votings from './votings'
import gameJams from './gameJams'
import wikigamer from './wikigamer'

const community = [
	...votings,
	...gameJams,
	...contents,
	...contentEngine,
	...contentRequests,
	...guestWriterInvites,
	...esports,
	...communityM,
	...communities,
	...wikigamer,
	...appThemes,
	...accountBenefits,
	...reports,
	...showcaseCoverage,
	...moderation,
	...gameClaims,
	...gameContributions,
	...gameCreationSuggestions,
	{
		path: '/community/dashboard',
		name: 'community-dashboard',
		component: () => import('@/views/community/dashboard/Index.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/messages',
		name: 'community-messages-list',
		component: () => import('@/views/messages/Messages.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/newsletter',
		name: 'community-newsletter-list',
		component: () => import('@/views/newsletters/Newsletter.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/releases',
		name: 'community-releases-list',
		component: () => import('@/views/community/releases/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
	{
		path: '/community/notifications',
		name: 'community-notifications-list',
		component: () => import('@/views/notifications/Notifications.vue'),
		meta: {
			layout: 'content',
			module: 'MGC,community',
		},
	},
]

export default community
